import {
  CreditCard,
  Gear,
  Headset,
  Receipt,
} from '@unified-checkout/design-system/icons/index';
import { Buildings } from '../assets/icons';

export const INNER_ROUTES = {
  PURCHASE_HISTORY: '/purchase-history',
  PAYMENT_METHODS: '/payment-methods',
  ADDRESSES: '/addresses',
  SETTINGS: '/settings',
  PASSKEYS: '/Passkeys',
  FAQS: '/faqs',
};
export const OUTER_ROUTES = {
  LOGIN: '/login',
};

export const mainNavLinks = [
  {
    label: 'Payment methods',
    icon: CreditCard,
    route: INNER_ROUTES.PAYMENT_METHODS,
  },
  {
    label: 'Addresses',
    icon: Buildings,
    route: INNER_ROUTES.ADDRESSES,
  },
  {
    label: 'Purchase History',
    icon: Receipt,
    route: INNER_ROUTES.PURCHASE_HISTORY,
  },
];

export const secNavLinks = [
  {
    label: 'Support',
    icon: Headset,
  },
  {
    label: 'Settings',
    icon: Gear,
    route: INNER_ROUTES.SETTINGS,
  },
];
